import { getStyledElementProps } from '@/utils'
import React, { FC } from 'react'

import { Typography } from '@/atoms'
import { FileInputProps } from '@/types'

import styles from './file-input.module.scss'

export const FileInput: FC<FileInputProps> = ({
  name,
  multiple,
  onChange,
  onBlur,
  value = '',
  logoUrl = '',
  mainDefaultText = 'Archivo',
  buttonText = 'Examinar',
  wrapperProps = {},
  buttonProps = {},
  inputProps = {},
  alt = 'logotipo',
  width = '40',
  height = '40',
  loading = 'lazy',
}) => {
  const styledWrapperProps = getStyledElementProps(
    wrapperProps,
    styles['wrapper']
  )
  const styledButtonProps = getStyledElementProps(buttonProps, styles['button'])
  const styledInputProps = getStyledElementProps(inputProps, styles['input'])
  return (
    <span {...styledWrapperProps}>
      <input
        type="file"
        name={name}
        value={value}
        multiple={multiple}
        onChange={onChange}
        onBlur={onBlur}
        {...styledInputProps}
      />
      <Typography variant={'body-1'} typographyColor={'gray-4'}>
        {mainDefaultText}
      </Typography>

      <button {...styledButtonProps}>
        <Typography variant={'small-1'} typographyColor={'gray-6'}>
          {buttonText}
        </Typography>
      </button>
      <div>
        <img
          src={logoUrl}
          alt={alt}
          width={width}
          height={height}
          loading={loading}
        />
      </div>
    </span>
  )
}
